import { useEffect } from 'react'
import { useLocalStorage } from 'usehooks-ts'
import {
  LOCAL_STORAGE_KEY_SIDEBAR_STATUS,
  DEFAULT_SIDEBAR_STATUS,
  SidebarStatus,
} from '@npm-client-frontends/shared-hooks'

export const useUpdateSidebarStatusLocalStorage = (
  visible: boolean,
  expanded: boolean,
) => {
  const [, setValue] = useLocalStorage(
    LOCAL_STORAGE_KEY_SIDEBAR_STATUS,
    DEFAULT_SIDEBAR_STATUS,
  )

  useEffect(() => {
    if (!visible) {
      setValue(SidebarStatus.HIDDEN)
    } else if (!expanded) {
      setValue(SidebarStatus.COLLAPSED)
    } else {
      setValue(SidebarStatus.EXPANDED)
    }
  }, [visible, expanded])
}
